var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "question-slider f-3" }, [
    _c(
      "div",
      {
        ref: "leftArrow",
        staticClass: "arrow left-arrow as-flex main-center cross-center",
        on: {
          click: function ($event) {
            return _vm.goScroll(0)
          },
        },
      },
      [_c("i", { staticClass: "el-icon-caret-left" })]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        ref: "content",
        staticClass: "content as-flex main-start cross-center",
      },
      [
        _vm._l(_vm.movieListBriefInfo, function (item, index) {
          return [
            _c(
              "transition-group",
              {
                key: "movie_" + index,
                staticClass: "as-full-height",
                attrs: { name: "flip-list" },
              },
              [
                _c(
                  "div",
                  {
                    key: "movie_" + index,
                    ref: "imgContainer",
                    refInFor: true,
                    class: [
                      "movie-box",
                      "as-flex",
                      "flex-vertical",
                      "main-center",
                      "cross-center",
                      !_vm.movieActive[item.id] ? "is-not-active" : "",
                    ],
                    on: {
                      click: function (e) {
                        _vm.toggleActive(item.id)
                        _vm.setCurrentQuestionRect(e)
                      },
                    },
                  },
                  [
                    item.poster_url
                      ? [
                          _c("img", {
                            staticClass: "img",
                            attrs: { src: item.poster_url, alt: "" },
                          }),
                        ]
                      : [
                          _c("img", {
                            staticClass: "img",
                            attrs: {
                              src: require("../../assets/images/movie-poster.png"),
                              alt: "",
                            },
                          }),
                        ],
                    _vm._v(" "),
                    _c("span", { staticClass: "movie-info title f-2" }, [
                      _vm._v(_vm._s(item.title)),
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      { staticClass: "movie-info f-1 fc-gray-2 title" },
                      [_vm._v(_vm._s(item.launch))]
                    ),
                  ],
                  2
                ),
              ]
            ),
          ]
        }),
      ],
      2
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        ref: "rightArrow",
        staticClass: "arrow right-arrow as-flex main-center cross-center",
        on: {
          click: function ($event) {
            return _vm.goScroll(1)
          },
        },
      },
      [_c("i", { staticClass: "el-icon-caret-right" })]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }